import PropTypes from 'prop-types';
import {createUseStyles} from 'react-jss';

const useStyles = createUseStyles({
  skeletonBox: {
    width: props => props.width,
    height: props => props.height,
    background: '#f2f2f2',
    position: 'relative',
    overflow: 'hidden',
    '&:after': {
      content: '""',
      position: 'absolute',
      top: 0,
      width: '100%',
      height: '100%',
      background: 'linear-gradient(85deg, #f2f2f2, #fafafa, #f2f2f2)',
      animation: '$loading 1.5s infinite',
    },
  },
  
  // Animations
  '@keyframes loading': {
    '0%': {
      left: '-100%',
    },
    '100%': {
      left: '100%',
    },
  },
});

export default function SkeletonBox(props) {
  const classes = useStyles(props);
  
  return (
    <div className={classes.skeletonBox} />
  );
}

SkeletonBox.defaultProps = {
  width: '100%',
  height: '100%',
};

SkeletonBox.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
